<template>
  <van-dialog :showConfirmButton="false" v-model:show="show" title="绑定手机号">
    <van-field v-model="phone" label="手机号" type="number" placeholder="请输入手机号" />
    <van-field
      v-model="code"
      center
      clearable
      label="短信验证码"
      placeholder="请输入短信验证码"
    >
      <template #button>
        <van-button color="#EB2135" @click="sendcode" size="small" type="primary">
          {{ !is_send ? '发送验证码' : code_num }}
        </van-button>
      </template>
    </van-field>
    <div @click="toWechat" class="phone_btn">
      <span>绑定手机号</span>
    </div>
  </van-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { showToast } from 'vant';
import api from '@/api';
// 定义props
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

// 定义emits
const emit = defineEmits(['update:modelValue']);

// 创建store实例
const store = useStore();
const route = useRoute();

// 数据定义
const show = ref(false);
const phone = ref('');
const code_num = ref(60);
const is_send = ref(false);
const code = ref('');


// 方法定义
const toWechat = async () => {
  if (!phone.value) {
    showToast('请输入手机号');
    return;
  }
  if (!code.value) {
    showToast('请输入验证码');
    return;
  }

  const post_data = {
    mobile: phone.value,
    active_id: route.query.id || 714,
    token: route.query.token || '',
    code: code.value
  };

  try {
    const res = await api.wechatMobile(post_data);
    if (res) {
      store.commit('setToken', route.query.token || '');
      store.commit('setInfo', res.data);
      showToast('绑定成功');
      show.value = false;
    }
  } catch (error) {
    console.error('绑定失败:', error);
    showToast('绑定失败，请重试');
  }
};

const sendcode = async () => {
  if (is_send.value) {
    return;
  }

  if (!phone.value) {
    Toast('请先输入手机号');
    return;
  }

  is_send.value = true;

  const post_data = {
    'RMT-From': 'Wechat',
    'mobile': phone.value,
    'token': route.query.token || ''
  };

  try {
    const res = await api.sendCode(post_data);
    if (res) {
      showToast('发送成功');    
      code_time();
      console.log(res);
    } else {
      is_send.value = false;
    }
  } catch (error) {
    console.error('发送验证码失败:', error);
    Toast('发送验证码失败，请重试');
    is_send.value = false;
  }
};

const code_time = () => {
  code_num.value = 60;
  const timer = setInterval(() => {
    if (code_num.value === 0) {
      clearInterval(timer);
      is_send.value = false;
    }
    code_num.value--;
  }, 1000);
};

// 暴露变量和方法给父组件
defineExpose({
  show,
  phone,
  code,
  code_num,
  is_send,
  toWechat,
  sendcode,
  code_time
});
</script>

<script>
// 如果需要选项API的部分，可以在这里定义
export default {
  name: 'PhoneDialog'
};
</script>

<style lang="scss">
    .van-dialog.van-dialog{
        background: #fff!important;
    }
.phone_btn {
  width: 194px;
  height: 69px;
  background: #EB2135;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto 20px;

  span {
    font-size: 24px;
    color: #FFF;
  }
}
</style>